module.exports = __webpack_public_path__ + "img/Input-Search-Dark.6b26b2f.svg";